import { boundActivityDisplayText } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityDisplayText'
import { buildCommittedStateExpiresAt } from 'tripPlanner/assistant/surfaceSnapshots/expiry'
import type { TripPlannerCommittedStateEntry } from 'tripPlanner/assistant/surfaceSnapshots/committedStateEntry'
import { formatExperienceSearchDisplayText, type ExperienceSearchDateRange } from './formatExperienceSearchDisplayText'

// Keyed per stop (matching `resolveSearchDefaults`'s own per-stop lookup and the retiring
// `appendRecentSearchHiddenContext`'s own `trip_stop_id` disambiguation) -- a flat key would
// regress real, already-shipped search-default behavior. No stopless fallback: this drawer is
// only ever opened with a stop in context, unlike flight search's own genuinely stopless case.
export function buildLastExperienceSearchCommittedStateEntry(
  stopId: number,
  searchQuery: string,
  dateRange: ExperienceSearchDateRange,
  occupancies: Array<App.Occupants>,
): TripPlannerCommittedStateEntry {
  return {
    key: `search:experience:stop:${stopId}`,
    kind: 'last_experience_search',
    label: 'Last experience search',
    displayText: boundActivityDisplayText(formatExperienceSearchDisplayText(searchQuery, dateRange, occupancies)),
    sourcePath: 'trip_planner.search.experience',
    dataClassification: 'personalised_surface',
    expiresAt: buildCommittedStateExpiresAt(),
  }
}
